// Tag — flat label attached to articles via `article_tags`. Mirrors
// the Drizzle row in `packages/db/src/schema/content/tags.ts`.
import { z } from 'zod';
const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
export const Tag = z.object({
    id: z.string().uuid(),
    slug: z
        .string()
        .regex(/^[a-z0-9](-?[a-z0-9])*$/)
        .min(1)
        .max(64),
    name: z.string().min(1).max(200),
    color: z.string().regex(HEX_COLOR_PATTERN),
    archivedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=tag.js.map